import client from '../base-api';

const serviceURL = '/travel-expenses';

const travelExpensesService = {

    // User
    getPendingAndActiveList(filterData: any) {
        return client.get(`${serviceURL}/pending-and-active`, {params: filterData});
    },
    getApprovedList(filterData: any) {
        return client.get(`${serviceURL}/approved`, {params: filterData});
    },
    getTravelExpensesDetails(id: number) {
        return client.get(`${serviceURL}/details/${id}`);
    },
    postTravelExpenses(data: any) {
        return client.post(`${serviceURL}`, data);
    },
    putTravelExpenses(data: any, id: number) {
        return client.put(`${serviceURL}/${id}`, data);
    },
    deleteTravelExpenses(id: number) {
        return client.delete(`${serviceURL}/delete/${id}`);
    },
    deleteTravelExpensesItem(id: number) {
        return client.delete(`${serviceURL}/delete-item/${id}`);
    },
    submitForApproval(id: number) {
        return client.put(`${serviceURL}/submit-for-approval/${id}`);
    },
    saveMessage(data: any) {
        return client.post(`${serviceURL}/save-message`, data);
    },
    getMessages(id: number) {
        return client.get(`${serviceURL}/messages/${id}`);
    },
    getItems(id: number){
        return client.get(`${serviceURL}/items/${id}`);
    },


    // Coordinator
    countNotificationForCoordinator(){
        return client.get(`${serviceURL}/coordinator/count-notification`);
    },
    getPendingAndActiveListForCoordinator(filterData: any) {
        return client.get(`${serviceURL}/coordinator/pending-and-active-list`, {params: filterData});
    },
    getApprovedListForCoordinator(filterData: any) {
        return client.get(`${serviceURL}/coordinator/approved-list`, {params: filterData});
    },
    getTravelExpensesCoordinatorDetails(id: number) {
        return client.get(`${serviceURL}/coordinator/details/${id}`);
    },
    coordinatorTravelExpensesApprove(id: number, approvedStatus: string) {
        return client.put(`${serviceURL}/coordinator/approve/${id}/${approvedStatus}`);
    },
    coordinatorTravelExpensesDecline(id: number) {
        return client.put(`${serviceURL}/coordinator/decline/${id}`);
    },
    coordinatorIsHr() {
        return client.get(`${serviceURL}/coordinator/is-hr`);
    },
}

export default travelExpensesService;